module.exports = __webpack_public_path__ + "static/media/copy.938f280b.svg";